<template>
<div>
	<Head></Head>
	<div class="frame-main" :class="{minSide:stage.setting.loc.sideMode==='min'}">
		<aside class="sideSys tra noSelect" v-if='showSide'>
			<button class="sizeCtrl" @click="sideModeChange">
				<Icon name="sizeCtrl" class="tra-fast" />
				<!-- <span class="fa fa-angle-double-left fs14x tra"></span> -->
			</button>
			<SideNav></SideNav>
			<!--
			<div id="time" class="tra tra_E">
				<div class="time">{{stage.time.utc+stage.time.offset|time("%H:%M:%S","utc")}}</div>
				<div><span class="date">{{stage.time.utc+stage.time.offset|time("%Y/%m/%d","utc")}}</span><span class="week ml05x tra">{{stage.time.week}}</span></div>
				<div class="zone"><span class="cityName tra ml05x"></span></div>
				<a href="file/人人光伏（专业版）更新记录.xls" download="人人光伏（专业版）更新记录.xls" class="ver" title="点击下载历史版本更新记录" target="_blank">
					<span class="prefix">{{$t("word805",["当前版本："])+": "}}</span>
					<span class="number">{{"v"+stage.ver}}</span>
				</a>
			</div>
			 -->
			 <dir class="ver cSub">{{"v"+stage.ver}}</dir>
		</aside>
		<section class="tra" :style="{left:showSide?'':'0px'}">
			<!-- <transition name="fade" mode="out-in" :duration="{enter:100,leave:100}"> -->
				<router-view></router-view>
			<!-- </transition> -->
		</section>
	</div>
</div>
</template>

<script>
import 'vue2-animate/dist/vue2-animate.min.css'

import * as lib from '@/util/lib.js'

import Head from '@/components/frame/Head.vue'
import SideNav from '@/components/frame/SideNav.vue'

import {apiGetDeviceConfigOption} from '@/api/device/order.js';

export default {
	name: 'frameMain',
	components: {Head, SideNav},
	 props: {
		showSide: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			stage
		}
	},
	methods: {
		sideModeChange: function () {
			stage.setting.loc.sideMode = stage.setting.loc.sideMode === 'min' ? 'def' : 'min'
			if (stage.setting.loc.sideMode === 'min') {
				// $(".menuClass[status='show']").attr("status","hide");//收起所有子菜单
				$('.sideSys').css({'pointer-events': 'none'})
				setTimeout(function () {
					$('.sideSys').css({'pointer-events': ''})
				}, 1000)
			}
			// $(".sideSys .sizeCtrl").click(function(){
			// 	$("body").toggleClass("minSide");//侧边菜单伸缩
			// 	screenFix(1000);
			// 	if($("body").hasClass("minSide")){
			// 		$(".sideSys .sizeCtrl").attr("disabled",true);
			// 		$(".logoBox>:last").fadeOut(200,function(){
			// 			$(".logoBox>").first().fadeIn(200);
			// 			$(".sideSys .sizeCtrl").attr('disabled', false);
			// 		});
			// 	}
			// 	else{
			// 		$(".sideSys .sizeCtrl").attr("disabled",true);
			// 		$(".logoBox>").first().fadeOut(200,function(){
			// 			$(".logoBox>:last").fadeIn(200);
			// 			$(".sideSys .sizeCtrl").attr('disabled', false);
			// 		});
			// 	};
			// 	// $(this).attr('disabled', false);
			// });
		}
	},
	mounted () {
		// $(window).resize(function(){//自动调用变化窗口需要执行的函数
		// 	$(stage.resize).each(function(){
		// 		this();
		// 	});
		// });
		// lib.startTime();
		// $(".sideSys").on("mouseleave",function(){//移开后收起所有子菜单
		// 	if(stage.setting.loc.sideMode==="min"){
		// 		$(".menuClass[status='show']").attr("status","hide");
		// 	}
		// });
		$('.sideSys').on('mouseenter', function () { // 主动打开子菜单所在二级菜单
			if (stage.setting.loc.sideMode === 'min') {
				let $parent = $('.menuList .active').parents('.menuList').first()
				if ($parent.prev('.menuClass').length > 0) $parent.prev('.menuClass').attr('status', 'show')
			}
		});
		// if(!window.deviceConfigOption){
		// 	apiGetDeviceConfigOption().then(success=>{
		// 		trace(success,true)
		// 	});
		// }
	}
}
</script>

<style lang="scss" scoped>
.ver{margin{top:0;bottom:0;};padding:0 .5em;position:fixed;bottom:0;left:0;text-align:left;opacity:.1;
	&:hover{opacity:.6;}
}
</style>



// WEBPACK FOOTER //
// src/view/frame/Main.vue